import { usePreview } from "react-dnd-preview";
import * as React from "react";
import { GetPreviewToDisplay } from "source/app/presentation/Preview/GetPreviewToDisplay";

export function ReactDndPreview() {
    const preview = usePreview();

    if (!preview.display) {
        return null;
    }
    const { itemType, item, style } = preview;

    const previewToDisplay = GetPreviewToDisplay(preview);

    return (
        <div className="item-list__item" style={style}>
            {previewToDisplay}
        </div>
    );
}


